// extracted by mini-css-extract-plugin
export default {"policyContainer":"privacyPolicy_policyContainer__y-+hM","policyWrapper":"privacyPolicy_policyWrapper__Sql2L"};